class BreezeSubscriptionWidget extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.addEventListener('change', this.handlePurchaseTypeChange);
    this.addEventListener('click', this.handleFrequencyClick);
    this.variantEventTarget = this.closest('.shopify-section') || document;
    this.variantEventTarget.addEventListener('variant:update', this.handleVariantUpdate);
    this.syncState();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handlePurchaseTypeChange);
    this.removeEventListener('click', this.handleFrequencyClick);
    this.variantEventTarget?.removeEventListener('variant:update', this.handleVariantUpdate);
    delete this.dataset.initialized;
  }

  get nativeControls() {
    return this.closest('product-form-component')?.querySelector('.product-form-buttons');
  }

  get breezeCheckout() {
    return this.querySelector('[data-breeze-checkout]');
  }

  get breezeButton() {
    return this.querySelector('breeze-button');
  }

  handlePurchaseTypeChange = (event) => {
    if (!event.target.matches('input[type="radio"]')) return;
    this.syncState();
  };

  handleFrequencyClick = (event) => {
    const frequencyButton = event.target.closest('[data-plan-id]');
    if (!frequencyButton || !this.contains(frequencyButton)) return;

    this.querySelectorAll('[data-plan-id]').forEach((button) => {
      const isActive = button === frequencyButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    this.breezeButton?.setAttribute('subscriptionplanid', frequencyButton.dataset.planId);
  };

  handleVariantUpdate = (event) => {
    const updatedWidget = event.detail?.data?.html?.querySelector('product-form-component breeze-subscription-widget');

    if (updatedWidget) {
      const selectedPurchaseType = this.querySelector('input[type="radio"]:checked')?.value;
      const selectedPlanId = this.querySelector('[data-plan-id].is-active')?.dataset.planId;
      const replacement = updatedWidget.cloneNode(true);

      replacement.querySelectorAll('input[type="radio"]').forEach((radio) => {
        const isSelected = radio.value === selectedPurchaseType;
        radio.checked = isSelected;
        radio.toggleAttribute('checked', isSelected);
      });

      replacement.querySelectorAll('[data-plan-id]').forEach((button) => {
        const isActive = button.dataset.planId === selectedPlanId;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      this.replaceWith(replacement);
    } else {
      if (this.nativeControls) this.nativeControls.hidden = false;
      this.remove();
    }
  };

  syncState() {
    const available = this.dataset.available === 'true';
    const selectedOption = this.querySelector('input[type="radio"]:checked');
    const isSubscription = selectedOption?.value === 'subscription';

    if (!available) {
      if (this.nativeControls) this.nativeControls.hidden = false;
      if (this.breezeCheckout) this.breezeCheckout.hidden = true;
      return;
    }

    if (this.nativeControls) this.nativeControls.hidden = isSubscription;
    if (this.breezeCheckout) this.breezeCheckout.hidden = !isSubscription;

    if (isSubscription) {
      const activeFrequency = this.querySelector('[data-plan-id].is-active');
      if (activeFrequency?.dataset.planId) {
        this.breezeButton?.setAttribute('subscriptionplanid', activeFrequency.dataset.planId);
      }
    }
  }
}

if (!customElements.get('breeze-subscription-widget')) {
  customElements.define('breeze-subscription-widget', BreezeSubscriptionWidget);
}

if (!window.breezeSubscriptionModalInitialized) {
  window.breezeSubscriptionModalInitialized = true;

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-subscription-modal-open]');
    const closeButton = event.target.closest('[data-subscription-modal-close]');
    const modal = document.querySelector('[data-subscription-modal]');

    if (!(modal instanceof HTMLDialogElement)) return;

    if (openButton) {
      modal.showModal();
      return;
    }

    if (closeButton || event.target === modal) {
      modal.close();
    }
  });
}
